import { useTranslation } from "react-i18next";
import type { HumanStepRequestedPayload } from "../../../api/threads/liveMessages";
import MarkdownRenderer from "../../../ui/content/MarkdownRenderer";

type AnsweredTalk = NonNullable<HumanStepRequestedPayload["answered_talk"]>;

/**
 * What the person asked the agent and what it answered, at the top of the review the talk
 * renewed (F105, TR-B1b-04): the answer sits where the person reviews again, not up the log.
 */
export default function TalkAnswer({ talk }: { talk: AnsweredTalk }) {
  const { t } = useTranslation();
  return (
    <div className="app-surface-muted space-y-1 rounded p-3 text-sm">
      <p>
        <span className="app-text-muted text-xs">{t("threads.talk.asked")} </span>
        <span className="whitespace-pre-wrap">{talk.request}</span>
      </p>
      <p className="app-text-muted text-xs">{t("threads.talk.answered")}</p>
      {talk.answer === null ? (
        <p className="app-text-muted text-xs">{t("threads.talk.noAnswer")}</p>
      ) : (
        <MarkdownRenderer content={talk.answer} className="app-markdown text-sm" />
      )}
    </div>
  );
}
